import { CircleX } from "lucide-react";
import "./decision.scss";

// ─── DATA ────────────────────────────────────────────────────────────────────
const decisionData = {
  decisionStage: "Credit Bureau Check",
  reason: "Low bureau Score. Multiple delinquencies.",
  approvedBy: "Ramesh Singh",
  approvedAt: "Dec 23, 08:29PM",
};

// ─── HELPERS ─────────────────────────────────────────────────────────────────
function initials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

// ─── DECISION CARD ───────────────────────────────────────────────────────────
export default function DecisionCard() {
  return (
    <div className="dc">
      {/* Red header */}
      <div className="dc__header">
        <span className="dc__header-title">FINAL DECISION</span>
      </div>

      {/* Body */}
      <div className="dc__body">

        {/* REJECTED row */}
        <div className="dc__status-row">
          <CircleX size={18.91} strokeWidth={1.8} className="dc__status-icon" />
          <span className="dc__status-label">REJECTED</span>
        </div>

        {/* Decision Stage */}
        <div className="dc__field">
          <span className="dc__field-label">Decision Stage:</span>
          <span className="dc__field-value dc__field-value--red">
            {decisionData.decisionStage}
          </span>
        </div>

        {/* Reason */}
        <div className="dc__field">
          <span className="dc__field-label">Reason:</span>
          <span className="dc__field-value">{decisionData.reason}</span>
        </div>

        {/* Divider */}
        <div className="dc__divider" />

        {/* Approver row */}
        <div className="dc__approver">
          <div className="dc__avatar">{initials(decisionData.approvedBy)}</div>
          <div className="dc__approver-info">
            <span className="dc__approver-name">{decisionData.approvedBy}</span>
            <span className="dc__approver-time">{decisionData.approvedAt}</span>
          </div>
        </div>

      </div>
    </div>
  );
}
